import { ViewPage } from './ViewPage';

export default ViewPage;
export * from './ViewPage';
